<template>
  <div>
    <PublicLayout>
      <header
        class="header"
        :style="{
          backgroundImage: `url(${require('@/assets/public/images/safety/header.jpg')})`,
        }"
      >
        <div class="container">
          <h1>Chất lượng của Fudizi<!--富地滋的品質--></h1>
        </div>
      </header>
      <HeaderNav activeLink="safety" />
      <!-- main-section -->
      <section class="main-section">
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title text-primary text-center">
              Thiết lập một hệ thống đảm bảo chất lượng đáng tin cậy để mọi người cảm thấy an toàn và yên tâm.
              <!--建構確實的品質保證體制， 讓每一個人感到安全及安心。-->
            </h2>
            <div class="row justify-content-center mb-5">
              <div class="col-md-6">
                <img
                  src="@/assets/public/images/safety/safty_kanri.jpg"
                  class="w-100"
                  alt
                />
              </div>
            </div>
            <h2 class="section-title">FORDAYS Nhà máy Gifu<!--FORDAYS歧阜工場--></h2>
            <p class="mb-0">
              Để bảo vệ sự "an toàn và bảo mật" của các sản phẩm FORDAYS, FORDAYS đã thành lập nhà máy Gifu vào năm 2017.
              <br />
              Tại nhà máy Gifu, chúng tôi sử dụng nước được sản xuất trong môi trường thiên nhiên phong phú của nơi đây để 
              tạo ra nước uống đạt tiêu chuẩn. Nước uống này được sử dụng làm nguyên liệu thô và xử lý bằng than hoạt tính, 
              khử ion và lọc chính xác để tạo ra nước đạt tiêu chuẩn nước tinh khiết dùng trong y tế.
              <br />
              Tất cả nguyên liệu thô sẽ được kiểm tra nghiêm ngặt trước khi đưa vào nhà máy.
              Để ngăn ngừa vật lạ bên ngoài trộn lẫn vào, Thiết bị sản xuất được đặt trong phòng sạch.
              Người vận hành phải mặc quần áo không có bụi và phải đi qua phòng tắm bụi trước khi vào khu vực sản xuất.
            </p>
            <!--<p class="mb-0">
            為了守護FORDAYS製品的「安全及安心」，2017年FORDAYS設立了歧阜工場。
              <br />
              在岐阜工場內，我們使用在地豐富自然環境中所產生的水來製作標準飲用水。並以此飲用水作為原料，經過活性碳、去離子及精密過濾的處理，製作出符合醫療用精製水標準的水加以利用。
              <br />
              所有各種原物料都會經過嚴格的檢查才能帶進工場內。而為了避免外部的異物混入，製造設備皆設置在無塵室內。作業員都必須穿著無塵衣且須通過空氣浴塵室才能進到生產區域內。
            </p>-->
            <div class="row justify-content-center my-5">
              <div class="col-md-6">
                <img
                  src="@/assets/public/images/safety/factory01.jpg"
                  class="w-100"
                  alt
                />
              </div>
            </div>
            <div class="row justify-content-center mt-3">
              <div class="col-md-12">
                <p>
                  Sau khi cân nguyên liệu, trộn, lọc, khử trùng, đổ đầy thùng chứa, rót chai để khử trùng, làm mát, loại bỏ độ ẩm, 
                  kiểm tra trực quan, ghi nhãn, đóng gói và kiểm tra chất lượng nghiêm ngặt cuối cùng, thành phẩm được coi là hoàn chỉnh. 
                  Nhà máy Gifu đã giới thiệu nhiều thiết bị mới nhất và áp dụng tất cả các hoạt động tự động hóa sau quá trình phối hợp.
                  <!--經過原料秤重、調和、過濾、殺菌、容器填充、倒瓶殺菌、冷卻、去除水分、目視檢查、標籤黏貼、包裝及最後嚴密的品質檢查後才算是完成的製品。
                  歧阜工場導入了各種最新型的設備，並在調和工程之後全部採用自動化作業。-->
                </p>
              </div>
              <div class="col-md-6 mt-5">
                <img
                  src="@/assets/public/images/safety/factory02.jpg"
                  class="w-100"
                  alt
                />
              </div>
            </div>
          </div>
        </section>
        <!-- m-sec -->
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">Trung tâm quản lý chất lượng<!--品質管理中心--></h2>
            <p>
              Để bảo vệ "sự an toàn và bảo mật" cho sản phẩm của mình, FORDAYS đã thành lập "Trung tâm quản lý chất lượng FORDAYS" tại Cao nguyên Izu, 
              tỉnh Shizuoka vào năm 2009. Trung tâm Quản lý Chất lượng, bắt đầu với đồ uống axit nucleic, lấy mẫu sản phẩm (bao gồm cả thực phẩm và 
              sản phẩm chăm sóc da) được sản xuất tại các nhà máy trên toàn quốc, lưu trữ theo số lô sản xuất và xác nhận rằng sản phẩm nằm trong 
              khoảng thời gian đảm bảo chất lượng cho đến hết giai đoạn bảo đảm chất lượng. -Kiểm tra độ lão hóa và chấp nhận lô hàng. Để đảm bảo 
              chất lượng sản phẩm, chúng tôi sẽ xây dựng một hệ thống đảm bảo chất lượng để khách hàng cảm thấy thoải mái. 
              <!--FORDAYS為了守護製品的「安全及安心」，2009年於靜岡縣的伊豆高原設立了「FORDAYS品質管理中心」。品質管理中心以核酸飲品為首，
              將全國各地的工場所製造的產品取樣(包含食品與保養品)，依照生產批號進行保存，並透過出貨前的驗收及通過時效測試確認產品在品質保證期間內的安定性等來確保製品的品質，
              建構讓顧客都能感到安心的品質保證體制。-->
              <br />
              Để xây dựng hệ thống đảm bảo chất lượng, chúng tôi không chỉ thực hiện kiểm soát chất lượng sản phẩm mà còn triển khai một loạt hệ 
              thống đảm bảo chất lượng từ xác nhận chất lượng nguyên liệu thô đến chất lượng sản xuất trong nhà máy và chất lượng ở khâu hậu cần, 
              và sau đó cho đến khi khách hàng đã sử dụng sản phẩm.
              <!--為了建構品質保證體制，不單單只是進行製品的品質管理，更是從原料的品質確認到工場的製造品質、物流階段的品質，然後一直到顧客們使用完製品後整體一連串的品質保證體制。-->
            </p>
            <div class="row justify-content-center">
              <div class="col-md-6 my-5">
                <img
                  src="@/assets/public/images/safety/photo_safety02.jpg"
                  class="w-100"
                  alt
                />
              </div>
              <div class="col-md-12 mt-3">
                <p>
                  Giám sát, kiểm tra nhà máy cũng là một trong số đó. Nhân sự từ trung tâm quản lý chất lượng sẽ đến nhà máy sản xuất để giám sát, 
                  kiểm tra dây chuyền sản xuất, sau đó trao đổi với người phụ trách sản xuất & quản lý chất lượng của nhà máy về cách cải tiến chất lượng.
                  Thông qua việc tích lũy kinh nghiệm, chúng tôi sẽ xây dựng một hệ thống đảm bảo chất lượng mạnh mẽ hơn.
                  <!--工場監督檢查也是其中之一。品質管理中心的人員會前往製造工場進行生產線的監督檢查，並在之後和工場的生產&amp;品質管理負責人討論如何能夠更加提升品質。
                  藉由經驗的累積，建構更堅固的品質保證體制。-->
                </p>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-md-6 my-5">
                <img
                  src="@/assets/public/images/safety/photo_safety03.jpg"
                  class="w-100"
                  alt
                />
              </div>
              <div class="col-md-12 mt-3">
                <p>
                  Ngoài ra, các hoạt động như chiết xuất DNA tinh hoàn cá hồi và làm kem dưỡng da tay cũng được tổ chức để các bạn hiểu rõ hơn về sự tiến 
                  bộ và an toàn của sản phẩm FORDAYS.
                  <!--另外，還舉辦了萃取鮭魚精巢DNA的體驗及製作護手霜的活動，進而從中更能了解FORDAYS製品的先進性與安全性。-->
                  <br />
                  Thông qua các chuyến tham quan học tập như vậy, mọi người có thể thực sự hiểu về sản phẩm và chúng tôi sẽ tiếp tục làm việc chăm 
                  chỉ để tạo ra các sản phẩm FORDAYS được mọi người yêu thích và an toàn hơn. Vì vậy, Trung tâm Quản lý Chất lượng có thể nói là cơ sở 
                  kết nối mọi người bằng niềm tin vào FORDAYS.
                  <!--透過這樣的學習參觀會，讓大家都能確實了解製品，我們也會持續努力讓FORDAYS的製品深受大家喜愛且更加安心。因此品質管理中心可說是連結大家與FORDAYS之間信賴的設施。-->
                </p>
              </div>
            </div>
          </div>
        </section>
        <!-- m-sec -->
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">Câu chuyện về axit nucleic<!--核酸的故事--></h2>

            <p>
              Nghiên cứu axit nucleic trên Salmon japonica có lịch sử lâu đời, bắt đầu từ năm 1871 (Minh Trị 4).
              Khoảng 80 năm trước, James Watson và Francis Crick đã phát hiện ra cấu trúc chuỗi xoắn kép của DNA. 
              Sau đó, qua nỗ lực của nhiều nhà nghiên cứu và phát triển công nghệ nổi tiếng, vật liệu hạt nhân thu được từ hạt cá hồi đã được tách 
              ra và đặt tên là “Axit Nucleic” (axit nucleic), phát triển như ngày nay.
            </p>
            <p>
              Đi đầu trong nghiên cứu axit nucleic ở Nhật Bản là Khoa Khoa học của Đại học Hoàng gia Tokyo (nay là Đại học Tokyo). 
              Giáo sư Eiro Ando của Đại học Hoàng gia Tokyo, người nghiên cứu dưới sự hướng dẫn của Giáo sư Udo Toturo, 
              là người đầu tiên trên thế giới giải thích được vấn đề về protamine(protein liên kết với DNA)Người đã phân tích thành công cấu trúc hóa học của(Showa 36) 
              Và sử dụng nó trong sinh học và y học. ăn được.
              Giáo sư Fujio Oegami ở Tokyo, người cũng nghiên cứu dưới sự hướng dẫn của Giáo sư Totokuro Udo, đang tham gia vào nghiên cứu liên quan đến axit nucleic 
              và enzyme. Ribonuclease T1 do Giáo sư Egami phát hiện đã đạt được tiến bộ trong phân tích cấu trúc chính của RNA chuyển do Holly và những người khác nghiên cứu.
              Vì vậy, trong Showa 43, Holly và những người khác đã được trao giải Nobel. Tại Showa 28, Giáo sư Egami và Giáo sư Ando đã cùng xuất bản cuốn sách nghiên cứu liên quan 
              đến axit nucleic đầu tiên của Nhật Bản "Axit nucleic và nucleoprotein - Vật lý, Hóa học, Sinh học, Y học -", 
              Nội dung của cuốn sách chủ yếu đề cập đến phương pháp chiết xuất và tinh chế axit nucleic và nucleoprotein, tính chất vật lý của axit nucleic và nucleoprotein, 
              phương pháp xử lý enzyme cũng như quan điểm y học và sinh học về axit nucleic và nucleoprotein. Có thể thấy, lịch sử lâu đời của việc nghiên cứu 
              axit nucleic đã phát triển cho đến ngày nay là nhờ sự nỗ lực của rất nhiều nhà nghiên cứu.
            </p>
            <p>
              Do đó, dựa trên các tính chất vật lý, chức năng và công nghệ chiết xuất axit nucleic và nucleoprotein đã được nuôi trồng cho đến nay, 
              đã có các cơ sở sản xuất để chiết xuất và xử lý nguyên liệu thô axit nucleic kể từ đó, 
              Ngày nay, hơn nửa thế kỷ sau, chúng tôi hoàn toàn cam kết sản xuất nguyên liệu thô axit nucleic cho mục đích y tế và thực phẩm, 
              đồng thời tiếp tục sản xuất nguyên liệu thô với công nghệ cao mà không có bất kỳ sai lệch nào.
              Thậm chí, trong số những người chịu trách nhiệm sản xuất, có một chuyên gia hàng ngày tiếp xúc với tinh hoàn đã hơn 50 năm.
              “Chỉ cần nhìn thấy tinh hoàn, mũi bạn sẽ chảy ra theo phản xạ”, 
              "Chỉ cần nhìn vào tinh hoàn là có thể biết được lượng nguyên liệu thu được (hàm lượng axit nucleic)".
              Và khi được hỏi:Có bất kỳ sai lệch nào trong các thành phần của nguyên liệu thô axit nucleic được chiết xuất không?
              Anh trả lời dứt khoát:Chúng tôi cũng sẽ điều chỉnh cho phù hợp nên không bao giờ có giá trị sai lệch.
            </p>
            <p>
              Là người tiên phong trong lĩnh vực dinh dưỡng axit nucleic, công ty chúng tôi coi việc phát triển và phổ biến nghiên cứu axit nucleic là trách 
              nhiệm của mình và đã làm việc chăm chỉ cho đến ngày nay.
              Chúng tôi không chỉ hợp tác với Đại học Showa, Đại học Tokyo và các tổ chức nghiên cứu khác,
              Đồng thời, nhiều bài giảng quyên góp cũng được tổ chức, 
              Tuy nhiên, trong quá trình nghiên cứu, nếu bạn không hiểu phương pháp sản xuất nguyên liệu axit nucleic, 
              không hiểu kết quả phân tích hoặc đôi khi có "giá trị sai lệch" thì sẽ trở thành nút thắt lớn và cản trở tiến độ nghiên cứu. 
              Do đó, nguyên liệu thô axit nucleic được sản xuất như thế nào, tính chất vật lý và chức năng của chúng là gì, 
              việc thu thập thông tin này là một yếu tố quan trọng để tiếp tục nghiên cứu. Ngoài ra, để tiếp tục cung cấp cho bạn các sản phẩm axit nucleic đáng tin cậy, 
              chúng tôi rất coi trọng tính đồng nhất và ổn định của nguyên liệu thô. Vì vậy, chúng tôi chưa bao giờ gặp phải vấn đề nào mà dù thế nào đi nữa 
              cũng không thể cải thiện được, thậm chí là tình huống mà cá nhân người phụ trách không thể giải quyết được.
            </p>
            <p>
              Chúng tôi không ngừng vắt óc suy nghĩ làm thế nào để "tiếp tục cung cấp những sản phẩm đáng để bạn tin tưởng, có cơ sở khoa học, 
              có cảm nhận thực tế, an toàn và bảo mật" và làm thế nào để "tiếp tục tạo ra những sản phẩm được cải tiến, phát triển và tốt hơn"; các sản phẩm".
            </p>
            <p>
              Chúng tôi coi mình là công ty tiên phong về dinh dưỡng axit nucleic Trong quá trình nghiên cứu hàng ngày, 
              chúng tôi gặp đủ thứ và gặp gỡ nhiều nhà nghiên cứu, nhà phát triển và kỹ thuật viên.
            </p>
            <p>
              Nhóm do Tiến sĩ Uzumi dẫn đầu sẽ tiếp tục tiếp tục các kết quả nghiên cứu của chúng tôi cho đến nay. Để phát triển từ một công ty tiên 
              phong về dinh dưỡng axit nucleic thành "người tiên phong về axit nucleic", chúng tôi quyết định tham gia phát triển nguyên liệu thô axit nucleic. 
              Đây là một trách nhiệm khác đối với các sản phẩm sau khi thành lập nhà máy sản xuất đồ uống axit nucleic của riêng chúng tôi.
            </p>
            <p>
              Năm 1871, lịch sử nghiên cứu axit nucleic sử dụng tinh hoàn cá hồi đã được hé lộ,
              Nguyên liệu thô axit nucleic ngày nay được tạo ra nhờ sự nhiệt tình của nhiều nhà nghiên cứu, nhà phát triển, kỹ thuật viên và nhà sản xuất.
              Chúng tôi làm việc với các chuyên gia đã tham gia nghiên cứu axit nucleic trong một thời gian dài, 
              Dựa trên nghiên cứu tiên tiến nhất, chúng tôi sẽ tiếp tục phát triển các nguyên liệu thô axit nucleic tốt hơn trong tương lai. 
              Điều này nhằm tạo ra một môi trường phát triển bền vững và có đầy đủ khả năng phát triển không giới hạn trong tương lai, 
              đồng thời mang đến cho các nhà nghiên cứu trẻ gánh vác tương lai một môi trường để xây dựng trên quá khứ, đặt nền móng cho "Fudizi 100 năm sau".
            </p>
            <p>
              Tại nhà máy riêng của Fudizhi mà chúng tôi thành lập vào năm 2017, việc "hình dung" địa điểm sản xuất là "bước tiến tới tương lai" của Fudizhi. 
              Và đối với mỗi nguyên liệu thô mà chúng tôi chú ý đến, chúng tôi cũng đang đẩy mạnh phát triển theo hướng “hình dung”.
            </p>
            <p>
              Công ty Fudizi luôn hướng tới việc theo đuổi những thứ thực sự có giá trị, chất lượng cao và làm việc chăm chỉ trong nghiên cứu và phát triển, 
              vì vậy chúng tôi tự tin cung cấp cho bạn những thứ tốt nhất!
            </p>


            <!--
            <p>
              以鮭魚精巢萃取的核酸研究歷史悠久，最遠可追溯到1871年(明治4年)。而在約80年前，華生(James Watson)與克里克(Francis Crick)兩位發現了DNA的雙重螺旋構造。而後透過許多著名的研究者和技術開發者的努力，進而將從鮭魚精巢取得的核物質進行分離，並取名為「Nucleic acid」(核酸)，一直發展至今日的模樣。
            </p>
            <p>
              日本核酸研究的領頭者為東京帝大(現東京大學)理學部。師事左右田徳郎教授的東京帝大
              安藤銳郎教授是世界上第一位將關於魚精蛋白(與DNA結合在一起的蛋白質)的化學構造成功解析的人(昭和36年)，並將之使用於生物學及藥劑．食用上。而同樣師事左右田徳郎教授的東京帝大
              江上不二夫教授是從事核酸和酵素相關的研究，江上教授發現的核糖核酸酶T1，讓Holly等人研究的轉移RNA的一級構造解析有所進展。因此在昭和43年，Holly等人得到了諾貝爾獎的肯定。在昭和28年，江上教授、安藤教授共同出版了日本最初的核酸相關研究書籍「核酸及核蛋白
              ―理化化學・生物學・醫學―」，書中內容主要是提及關於核酸・核蛋白的萃取・精製法、核酸和核蛋白的物理性質、酵素處理法、核酸和核蛋白的醫學及生物學的觀點見解等。由此可見源遠流長的核酸研究歷史能發展至今，是由許多研究者的努力而促成的。
            </p>
            <p>
              因此以培養至今的核酸及核蛋白的物理性質、機能性、萃取技術為基礎，從那時開始就有提取核酸原料來加工的製造場所，經過半世紀以上到了今日，也是全力投入醫療用・食品用的核酸原料製造，並持續著毫無偏差、高度技術的原料製造。甚至在製造責任者中，有一位長達50年以上每天都持續接觸著精巢的專業人士表示「只要看到精巢，鼻水就會條件反射地流出來」「只要看一眼精巢，就能知道原料的採收量(核酸含有量)」。而當被詢問到：「從精巢萃取的核酸原料的含有成分，有沒有出現偏差過？」。他斬釘截鐵地回答：「看到精巢後我們也會隨之調整，所以從來沒有出現偏差值過。」
            </p>
            <p>
              敝公司身為核酸營養的先驅企業，我們以核酸研究的發展與普及為己任而努力至今。我們不僅僅和昭和大學、東京大學及其他研究機關共同合作，同時也開設了許多捐贈講座，並和生命科學研究所共同進行基礎研究知識的探討。然而，研究進行中，若不明白核酸原料的製造方法、不能理解分析結果、偶爾出現「偏差值」的話，都會成為大瓶頸而妨礙研究的進行。因此核酸原料是如何製造的，帶有怎麼樣的物理性質和機能性，這些情報的獲得是研究可以持續進行的重要因素。另外，為了不斷提供給各位值得信賴的核酸產品，我們非常重視原料的均一性・安定性。所以我們從未發生無論如何都沒辦法改善的問題，甚至負責人親自出馬還沒辦法解決的狀況。
            </p>
            <p>
              我們不斷地絞盡腦汁、思考著該如何「持續提供值得各位信賴、擁有科學依據、確實感受且安心‧安全的產品」；又該如何「持續製造改良進化且更優質的產品」。
            </p>
            <p>
              我們以核酸營養的先驅企業為己任，在每天的研究過程中，遇到各式各樣的事情，也遇到了許多研究者‧開發者‧技術者們。
            </p>
            <p>
              而以宇住博士為領導的團隊，會持續將我們研究至今的成果發揚光大。為了從核酸營養的先驅企業，進化成「核酸的先鋒者」，我們決定要從事核酸的原料開發。這是繼成立自己的核酸飲品生產工場後，對產品應有的另一種責任。
            </p>
            <p>
              1871年揭開了以鮭魚精巢萃取的核酸研究歷史序幕，透過多位的研究者‧開發者‧技術者‧製造者的熱忱而創造出現在的核酸原料。我們與長久從事核酸研究的專業人士合作，並從中汲取他們的經驗及知識，以最先進的研究為基礎，今後仍不斷地開發更好的核酸原料。而這是為了開創一個永續且未來充滿無限發展可能性的開發環境，並且賦予肩負未來的年輕研究員擁有繼往開來的環境，奠定「100年後的富地滋」的基石。
            </p>
            <p>
              2017年我們設立的富地滋自家工場，其中生產現場「可視化」，是我們富地滋「邁向未來的一步」。並且對於講究的每個原料，也正朝著「可視化」的方向推動發展中。
            </p>
            <p>
              富地滋公司一直以來以追求真正有價值、優質的東西，努力研究並開發為目標，因此我們有信心提供給各位最好的！
            </p>
            -->
          </div>
        </section>
        <!-- m-sec -->
      </section>
      <!-- main-section -->
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "../../components/public/PublicLayout";
import HeaderNav from "../../components/public/headerNav/SafetyHeaderNav";
export default {
  name: "SafetyScreen",
  components: {
    PublicLayout,
    HeaderNav,
  },
};
</script>
